import {
	checkApi,
	getCheckMaintenanceData,
	postLogin,
} from "../../../helpers/backend_helper";
import { resetCampaignState, resetFacebook } from "../../campaigns/reducer";
import { resetFeedState } from "../../feeds/reducer";
import { resetFolderState } from "../../folder/reducer";
import { resetFontState } from "../../fonts/reducer";
import { resetAdformState, resetDcmState, resetPublishState } from "../../publish/reducer";
import { resetShowcaseState } from "../../showcase/reducer";
import { resetUploadedState, resetUploadState } from "../../uploads/reducer";
import { resetMenuDataState } from "../menu/reducer";
import { getMenuData } from "../menu/thunk";
import { resetPermissions } from "../permission/reducer";
import { getPermissionList } from "../permission/thunk";
import { resetSettingState } from "../settings/reducer";
import { getCompanyUsers } from "../settings/thunk";
import {
	loginSuccess,
	logoutUserSuccess,
	apiError,
	reset_login_flag,
	resetLoginState,
	setIsMaintenance
} from "./reducer";
import { push, replace } from "redux-first-history";
import Cookies from 'js-cookie';
import { resetAnalyticsState } from "../../analytics/reducer";
import { createAsyncThunk } from "@reduxjs/toolkit";
/**
 * Thunk function for initiating the user login process.
 * Dispatches actions based on the success or failure of the login process.
 * @param {Object} user - The user object containing login credentials (e.g., username, password).
 * @param {Function} history - The function to navigate to a different route in the application.
 * @param {Function} dispatch - The Redux dispatch function.
 * @throws {Error} If there is an error during the login process.
 */
export const loginUser = (user, history) => async (dispatch, getState) => {
	const {language} = getState().MenuData;
	try {
		let isMaintenance = await dispatch(getCheckMaintenance());
		if (isMaintenance.payload && isMaintenance.payload === true) {
			history('/maintenance');
			return;
		}
		let response = await postLogin({
			email: user.email,
			password: user.password,
		});
		var data = response;

		if (data) {
			if (data.status === "ok") {
				Cookies.set('authUser', JSON.stringify(data), {expires: 2});
				dispatch(loginSuccess(data));
				history("/");
			} else {
				dispatch(apiError(language[data.code]));
			}
		}
	} catch (error) {
		dispatch(apiError((language[error?.code] || 'Something went wrong')));
	}
};
/**
 * Thunk function for handling the login lock screen.
 * @returns {Function} An asynchronous function to be used with Redux Thunk middleware.
 * @throws {Error} If there is an error during the login lock screen process.
 * @async
 */
export const loginLockScreen = () => async () => {
	try {
		// loginLockScreen;
	} catch (error) {
		// console.log(error);
	}
};
/**
 * Thunk function for logging out a user.
 * @returns {Function} An asynchronous function to be used with Redux Thunk middleware.
 * @param {Function} dispatch - The Redux dispatch function.
 * @throws {Error} If there is an error during the logout process, an API error action is dispatched.
 * @async
 */
export const logoutUser = () => async (dispatch) => {
	try {
		dispatch(resetAnalyticsState());
		dispatch(resetUploadedState());
		dispatch(resetShowcaseState());
		dispatch(resetDcmState());
		dispatch(resetAdformState());
		dispatch(resetPublishState());
		dispatch(resetFontState());
		dispatch(resetFolderState());
		dispatch(resetFeedState());
		dispatch(resetCampaignState());
		dispatch(resetFacebook());
		dispatch(resetSettingState());
		dispatch(resetPermissions());
		dispatch(resetMenuDataState());
		dispatch(resetLoginState());
		Cookies.remove('authUser');
		dispatch(logoutUserSuccess(true));

	} catch (error) {
		dispatch(apiError(error));
	}
};

export const getCheckMaintenance = createAsyncThunk('auth/checkMaintenance', async (params, {dispatch, getState}) => {
  try {
    const res = await getCheckMaintenanceData();
    if (res.status === 'ok') {
      if (res.data.mode === 'maintenance') {
        dispatch(setIsMaintenance(true));
				return true;
      } else {
				dispatch(setIsMaintenance(false));
				return false;
			}
    } else {
      throw res;
    }
  } catch (error) {
    dispatch(setIsMaintenance(true));
		return true;
  }
});

/**
 * Thunk function for resetting the login flag.
 * @returns {Promise} A Promise that resolves when the login flag is successfully reset.
 * @param {Function} dispatch - The Redux dispatch function.
 * @throws {Error} If there is an error during the reset process, an API error action is dispatched.
 * @async
 */
export const resetLoginFlag = () => async (dispatch) => {
	try {
		const response = dispatch(reset_login_flag());
		return response;
	} catch (error) {
		dispatch(apiError(error));
	}
};